export const organizationI18n = {
  organization: {
    en: {
      COMPANY_DOCUMENTS: 'Company Documents',
      SELECT_COMPANY: 'Select company',
      SELECT_COMPANY_DESCRIPTION:
        'Your account is linked to multiple companies. Please select the company you want to work with to continue.',
    },
    'sv-SE': {
      COMPANY_DOCUMENTS: 'Företagsdokument',
      SELECT_COMPANY: 'Välj företag',
      SELECT_COMPANY_DESCRIPTION:
        'Ditt konto är kopplat till flera företag. Vänligen välj det företag du vill arbeta med för att fortsätta.',
    },
  },
};
